import { PlaycanvasEvent, PortalEvent } from '~/homebase/types/Homebase.types'

// ChoosePetTrick, DragonFull, DragonTrickCooldown, DragonTrickNotWilling, InfoAboutPetTrick add on the 14/2/22
export enum HomeBaseStoryCardId {
  ChoosePetTrick = 'ChoosePetTrick',
  ChooseYourEgg = 'ChooseYourEgg',
  CoolDown = 'CoolDown',
  CoolDownFirstTime = 'CoolDownFirstTime',
  DoNotHaveEnoughMnO = 'DoNotHaveEnoughMnO',
  DragonFull = 'DragonFull',
  DragonTrickCooldown = 'DragonTrickCooldown',
  DragonTrickNotWilling = 'DragonTrickNotWilling',
  DragonTutorial1 = 'DragonTutorial1',
  DragonTutorial2 = 'DragonTutorial2',
  DragonTutorial3 = 'DragonTutorial3',
  DragonTutorial4 = 'DragonTutorial4',
  EggHasBeenChosen = 'EggHasBeenChosen',
  EggHungry = 'EggHungry',
  EggInfoStillHatching = 'EggInfoStillHatching',
  EggIsAboutToHatch = 'EggIsAboutToHatch',
  FeedMathEnergyToEggFirstTime = 'FeedMathEnergyToEggFirstTime',
  GiveDragonName = 'GiveDragonName',
  InfoAboutPetTrick = 'InfoAboutPetTrick',
  MathEnergyTutorial1 = 'MathEnergyTutorial1',
  MathEnergyTutorial2 = 'MathEnergyTutorial2',
  NextHatchingState1 = 'NextHatchingState1',
  NextHatchingState2 = 'NextHatchingState2',
  NextHatchingState3 = 'NextHatchingState3',
}

export enum ChampionshipStoryCardId {
  TimesTableCompetition2021FirstPlace = 'TimesTableCompetition2021FirstPlace',
  TimesTableCompetition2021Participant = 'TimesTableCompetition2021Participant',
  TimesTableCompetition2021SecondPlace = 'TimesTableCompetition2021SecondPlace',
  TimesTableCompetition2021ThirdPlace = 'TimesTableCompetition2021ThirdPlace',
}

export type StoryCardId = HomeBaseStoryCardId | PortalEvent | PlaycanvasEvent | ChampionshipStoryCardId
